module.exports = __webpack_public_path__ + "img/kx5200-3.25118b08.png";